import service from "@/store/services/supply-rules-service";

export const state = () => ({
  list: {},
  widgetList: {},
  supplyRule: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_WIDGET_LIST: (state, list) => {
    state.widgetList = list;
  },
  SET_RESOURCE: (state, supplyRule) => {
    state.supplyRule = supplyRule;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },
  widgetList({ commit, dispatch }, params = {}) {
    return service.widgetList(params, this.$axios).then(({ list, meta }) => {
      commit("SET_WIDGET_LIST", list);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((supplyRule) => {
      commit("SET_RESOURCE", supplyRule);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((supplyRule) => {
      commit("SET_RESOURCE", supplyRule);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((supplyRule) => {
      commit("SET_RESOURCE", supplyRule);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  widgetList: (state) => state.widgetList,
  listTotal: (state) => state.meta.page.total,
  supplyRule: (state) => state.supplyRule,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((supplyRule) => ({
      id: supplyRule.id,
      name: `${supplyRule.name}`,
    }));
  },
};

const supplyRules = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default supplyRules;
